import { Flex, NumberInput, SimpleGrid, Switch, Textarea, TextInput } from '@mantine/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '@/containers/pages/filials/edit/styles';
import { useMediaQuery } from '@mantine/hooks';
import { UseFormReturnType } from '@mantine/form';
import { IMailServer } from '@/services/api/emailServerApiArea/types';

interface Props {
  form: UseFormReturnType<IMailServer>;
}

const SshForm = (props: Props) => {
  const { form } = props;
  const [showKey, setShowKey] = React.useState(!form.values.Integration?.Ssh?.HasKey);
  const { t } = useTranslation();
  const { classes } = useStyles();
  const isMobile = useMediaQuery('(max-width: 992px)');

  const toggleShowKey = () => setShowKey((prev) => !prev);

  return (
    <>
      <SimpleGrid cols={isMobile ? 1 : 2} mt={16} w="100%">
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.server')}
          label={t('servers.server')}
          withAsterisk
          {...form.getInputProps('Integration.Ssh.Server')}
        />
        <Flex
          className={classes.rightSideContainerTwoItems}
          gap="24px"
          direction={isMobile ? 'column' : 'row'}
        >
          <NumberInput
            className={classes.textFieldInput}
            autoComplete="off"
            maw={isMobile ? 'auto' : 70}
            placeholder={t('servers.port')}
            label={t('servers.port')}
            withAsterisk
            hideControls
            defaultValue=""
            mb={isMobile ? '20px' : ''}
            {...form.getInputProps('Integration.Ssh.Port')}
          />
          <TextInput
            w="100%"
            className={classes.textFieldInput}
            placeholder="Login"
            label="Login"
            withAsterisk
            {...form.getInputProps('Integration.Ssh.User')}
          />
        </Flex>
      </SimpleGrid>
      <SimpleGrid cols={1} mt={16} w="100%">
        {form.values.Integration?.Ssh?.HasKey && (
          <Switch
            checked={showKey}
            size="xs"
            onChange={toggleShowKey}
            label={t('servers.changeKey')}
          />
        )}
        {showKey && (
          <Textarea
            withAsterisk
            className={classes.textFieldInput}
            classNames={{ input: classes.textAreaInput }}
            label={t('servers.key')}
            size="xs"
            minRows={3}
            {...form.getInputProps('Integration.Ssh.PrivateKeyBase64')}
          />
        )}
      </SimpleGrid>
    </>
  );
};

export default SshForm;
